// assets
import { IconBook2, IconSearch, IconHelpCircle } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - KNOWLEDGE (A3) ||============================== //
// Bilgi Bankası: koleksiyonlar + versiyonlu makaleler + pgvector semantik arama.

const knowledge: NavItemType = {
  id: 'knowledge',
  title: 'knowledge', // react-intl key (utils/locales/en.json) - i18n-ready [STD-DRIFT]
  icon: IconBook2,
  type: 'group',
  requiredModule: 'knowledge',
  children: [
    {
      id: 'knowledge-articles',
      title: 'knowledge-articles',
      icon: IconBook2,
      type: 'item',
      url: '/knowledge/articles',
      module: 'kb.articles'
    },
    {
      id: 'knowledge-faq',
      title: 'knowledge-faq',
      icon: IconHelpCircle,
      type: 'item',
      url: '/knowledge/faq',
      module: 'kb.faq'
    },
    {
      id: 'knowledge-search',
      title: 'knowledge-search',
      icon: IconSearch,
      type: 'item',
      url: '/knowledge/search',
      permission: 'kb.search'
    }
  ]
};

export default knowledge;
